import React, { useEffect, useState } from "react";
import { Button, makeStyles, Slide } from "@material-ui/core";
import { watchuseek } from "../assets/assets";

const useStyles = makeStyles((theme) => ({
  arrow: {
    height: "100%",
    fontSize: "1rem",
    fontWeight: "600",
    minWidth: "20px",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.6)",
      color: "white",
    },
    position: "absolute",
  }
}));

const Carousel = ({ project, styles }) => {
  const classes = useStyles();
  const [carousel, setCarousel] = useState(1);

  useEffect(() => {
    setCarousel(1);
  }, [project]);

  const nextPage = () => {
    if (carousel === 7) {
      return setCarousel(1);
    }
    setCarousel(carousel + 1);
  };

  const prevPage = () => {
    if (carousel === 1) {
      return setCarousel(7);
    }
    setCarousel(carousel - 1);
  };

  return (
    <div className={styles.carousel}>
      {project === "watchuseek" && (
        <Button
          className={classes.arrow}
          style={{ left: "0" }}
          onClick={prevPage}
        >
          {"<"}
        </Button>
      )}
      <Slide
        className={classes.slide}
        direction="right"
        in={carousel === 1}
        mountOnEnter
        unmountOnExit
      >
        {project === "watchuseek" ? (
          <img
            style={{ width: "100%", borderRadius: "10px" }}
            src={watchuseek.home}
            alt=""
          />
        ) : (
          <iframe
            title="demos"
            width="100%"
            height="380"
            src={
              project === "mlsearch!"
                ? "https://www.youtube.com/embed/I-JOEsAy2Xo?autoplay=1&loop=1&playlist=I-JOEsAy2Xo&fs=1"
                : project === "henrycomics"
                ? "https://www.youtube.com/embed/BcBWaNt_fkQ?autoplay=1&loop=1&playlist=BcBWaNt_fkQ&fs=1"
                : project === "moonbank"
                ? "https://www.youtube.com/embed/lr6lsN3NdP4?autoplay=1&loop=1&playlist=lr6lsN3NdP4&fs=1"
                : project === "tagallery" &&
                  "https://www.youtube.com/embed/EsvAWMzESV4?autoplay=1&loop=1&playlist=EsvAWMzESV4&fs=1"
            }
            frameBorder="0"
            /* allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" */ allowfullscreen
          />
        )}
      </Slide>
      {project === "watchuseek" && (
        <>
          <Slide
            className={classes.slide}
            direction="right"
            in={carousel === 2}
            mountOnEnter
            unmountOnExit
          >
            <img
              style={{
                width: "100%",
                borderRadius: "10px",
              }}
              src={watchuseek.login}
              alt=""
            />
          </Slide>
          <Slide
            className={classes.slide}
            direction="right"
            in={carousel === 3}
            mountOnEnter
            unmountOnExit
          >
            <img
              style={{
                width: "100%",
                borderRadius: "10px",
              }}
              src={watchuseek.watches}
              alt=""
            />
          </Slide>
          <Slide
            className={classes.slide}
            direction="right"
            in={carousel === 4}
            mountOnEnter
            unmountOnExit
          >
            <img
              style={{
                width: "100%",
                borderRadius: "10px",
              }}
              src={watchuseek.detail}
              alt=""
            />
          </Slide>
          <Slide
            className={classes.slide}
            direction="right"
            in={carousel === 5}
            mountOnEnter
            unmountOnExit
          >
            <img
              style={{
                width: "100%",
                borderRadius: "10px",
              }}
              src={watchuseek.checkout}
              alt=""
            />
          </Slide>
          <Slide
            className={classes.slide}
            direction="right"
            in={carousel === 6}
            mountOnEnter
            unmountOnExit
          >
            <img
              style={{
                width: "100%",
                borderRadius: "10px",
              }}
              src={watchuseek.orders}
              alt=""
            />
          </Slide>
          <Slide
            className={classes.slide}
            direction="right"
            in={carousel === 7}
            mountOnEnter
            unmountOnExit
          >
            <img
              style={{
                width: "100%",
                borderRadius: "10px",
              }}
              src={watchuseek.profile}
              alt=""
            />
          </Slide>
          <Button
            className={classes.arrow}
            style={{ right: "0" }}
            onClick={nextPage}
          >
            {">"}
          </Button>
        </>
      )}
    </div>
  );
};

export default Carousel;
